<h2 mat-dialog-title class="dialog-title">
  {{ t.NewPatternTitle }}
</h2>

<mat-dialog-content class="dialog-content">
  <p class="intro">
    {{ t.NewPatternIntro }}
  </p>

  <mat-form-field appearance="outline" class="full-width">
    <mat-label>{{ t.NewPatternQuickPreset }}</mat-label>
    <mat-select
      [value]="selectedPresetKey"
      (selectionChange)="onPresetChange($event.value)"
    >
      <mat-option [value]="null">{{ t.NewPatternCustomSize }}</mat-option>
      <mat-optgroup [label]="t.NewPatternPopularProjects">
        <mat-option
          *ngFor="let preset of presets"
          [value]="preset.key"
        >
          {{ preset.label }} - {{ getPresetDescription(preset) }}
        </mat-option>
      </mat-optgroup>
    </mat-select>
  </mat-form-field>

  <div class="field-grid">
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>{{ t.NewPatternStitch }}</mat-label>
      <mat-select
        [value]="selectedStitchId"
        (selectionChange)="onStitchChange($event.value)"
      >
        <mat-option
          *ngFor="let stitch of stitches"
          [value]="stitch.stitchId"
        >
          {{ stitch.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>{{ t.NewPatternBeadType || 'Bead Type' }}</mat-label>
      <mat-select
        [value]="selectedBeadType"
        (selectionChange)="onBeadTypeChange($event.value)"
      >
        <mat-option
          *ngFor="let beadType of beadTypeOptions"
          [value]="beadType.id"
        >
          {{ beadType.label }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>{{ t.NewPatternColumns }}</mat-label>
      <input
        matInput
        type="text"
        inputmode="numeric"
        pattern="[0-9]*"
        min="5"
        max="500"
        [ngModel]="columns"
        (ngModelChange)="onColumnsInput($event)"
        (blur)="onColumnsBlur()"
        (click)="$event.target.select()"
        name="columns"
      />
      <mat-hint align="end">{{ columnSizeLabel }}</mat-hint>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>{{ t.NewPatternRows }}</mat-label>
      <input
        matInput
        type="text"
        inputmode="numeric"
        pattern="[0-9]*"
        min="5"
        max="500"
        [ngModel]="rows"
        (ngModelChange)="onRowsInput($event)"
        (blur)="onRowsBlur()"
        (click)="$event.target.select()"
        name="rows"
      />
      <mat-hint align="end">{{ rowSizeLabel }}</mat-hint>
    </mat-form-field>
  </div>

  <div class="size-preview">
    <mat-icon>straighten</mat-icon>
    {{ t.NewPatternApproximateSize }} <span>{{ physicalSizeSummary }}</span>
  </div>

  <p class="footnote">
    {{ dimensionsNote }}
  </p>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()">{{ t.NewPatternCancel }}</button>
  <button
    mat-flat-button
    color="primary"
    (click)="onConfirm()"
    [disabled]="!isValid()"
  >
    {{ t.NewPatternStart }}
  </button>
</mat-dialog-actions>
